module.exports = __webpack_public_path__ + "media/images/pc/plans/inclusion_39-9774b9481cb6e74cf98559d010978e4c.png";